const Settings = ({ size = 18, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="m375.5-90-16-125q-13.5-5-26.5-12.25t-24-15.25l-115.5 48-105-182 101-76.5q-1-6.48-1-12.49V-480q0-6 .25-13t1.25-16L88.5-584.5l105-181 117 49q10-8 22.25-15t26.75-13l16-126.5h209l16 125q14 5.5 25.75 12.75T649-716.5l117.5-49 105 181-104 77.54q1 6.96 1 12.71v28.92q0 6.18-1.5 12.83l103 76-105 182-116-49q-9.5 7.5-20.75 14T600.5-215l-16 125h-209Zm64.79-75H518l14.5-106.5q30-8 55-22.75T634-331l99.5 42 38.5-67-87-65q4.5-14 6.5-28.84t2-30.16q0-15.5-1.75-29.75T685-539l87-66-37.5-67-101 43q-19.5-21-46-36.5t-55-23L519.57-796H441l-13.5 107q-32 8.5-56 22.25T324-630l-98.5-42-38.5 67 85.5 63.5q-5 16-7 30.5t-2 30.47q0 15.03 1.75 29.53 1.75 14.5 6.75 31l-85 64 38.58 67 97.92-42q23.5 23.5 48.75 38t55.25 22l12.79 106Zm39.44-180q55.77 0 95.27-39.55 39.5-39.55 39.5-95.5t-39.54-95.45Q535.43-615 479.5-615q-56.5 0-95.75 39.55t-39.25 95.5q0 55.95 39.25 95.45t95.98 39.5Zm-.23-135.5Z" />
        </svg>
    )
}

export default Settings;